app.service('storageService', function() {
  
  // Session Storage - deleted as soon as browser is refreshed or closed.
  this.session_setItem = function(sKey, sValue) {
    sessionStorage.setItem(sKey, sValue);
  };

  this.session_getItem = function(sKey) {
    return sessionStorage.getItem(sKey);
  };

  this.session_removeItem = function(sKey) {
    sessionStorage.removeItem(sKey);
  };

  this.session_clear = function() {
    sessionStorage.clear();
  };

  //Local storage - remains even after Browser is closed and browser refreshes
  this.local_setItem = function(sKey, sValue) {
    return localStorage.setItem(sKey, sValue);
  };

  this.local_getItem = function(sKey) {
    return localStorage.getItem(sKey);
  };

  this.local_removeItem = function(sKey) {
    return localStorage.removeItem(sKey);
  };

  this.local_clear = function() {
    localStorage.clear();
  };

  // Cookie Storage
  this.setCookie = function(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  
  this.getCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  this.eraseCookie = function(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
  }

});
